/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bed, Bath, Maximize, ArrowRight, Home as HomeIcon, Building2 } from "lucide-react";
import { propertiesApi, photoUrl } from "./api";
import { formatInr } from "../utils/inrFormat";
import "./FeaturedProperties.css";

export default function FeaturedProperties() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    propertiesApi
      .featured()
      .then((r) => {
        if (!cancelled) setItems(r || []);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Hide entirely if there's nothing public yet — no "no listings" message
  // belongs on a marketing page.
  if (error || items.length === 0) return null;

  return (
    <section className="vs-featured" id="properties">
      <div className="container">
        <div className="vs-featured-head">
          <span className="vs-section-eyebrow">
            <Building2 size={14} /> Inside the community
          </span>
          <h2>Properties in Vishal Sanjivini</h2>
          <p className="vs-featured-sub">
            Villas listed for rent or sale by owners themselves.
          </p>
        </div>

        <div className="vs-featured-scroll">
          {items.map((p) => {
            const price =
              p.type === "RENT"
                ? formatInr(p.monthly_rent_inr, { monthly: true })
                : formatInr(p.expected_price_inr);
            const villaNum = p.villa?.villa_number || "—";
            return (
              <Link
                key={p.id}
                to={`/properties/${p.id}`}
                className="vs-featured-card"
              >
                <div className="vs-featured-card-img">
                  {p.primary_photo_url ? (
                    <img src={photoUrl(p.primary_photo_url)} alt={villaNum} />
                  ) : (
                    <div className="vs-featured-card-placeholder">
                      <HomeIcon size={32} strokeWidth={1.2} />
                    </div>
                  )}
                  <span
                    className={`vs-featured-card-type ${
                      p.type === "RENT" ? "rent" : "sale"
                    }`}
                  >
                    {p.type === "RENT" ? "For Rent" : "For Sale"}
                  </span>
                </div>
                <div className="vs-featured-card-body">
                  <h3>{villaNum}</h3>
                  <div className="vs-featured-card-bhk">
                    {p.bedrooms} BHK · Independent Villa
                  </div>
                  <div className="vs-featured-card-price">{price}</div>
                  <div className="vs-featured-card-icons">
                    <span>
                      <Bed size={12} /> {p.bedrooms}
                    </span>
                    <span>
                      <Bath size={12} /> {p.bathrooms}
                    </span>
                    <span>
                      <Maximize size={12} />{" "}
                      {p.built_up_area_sqft.toLocaleString("en-IN")} sqft
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="vs-featured-foot">
          <Link to="/properties" className="vs-btn-cta">
            Browse all properties <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
